import { faStars } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { MprcRequestErrorReport, MprcSpinnerIndicator } from 'components';
import { MprcSimpleDialog } from 'components/MprcSimpleDialog';
import { BadgeInfoResponse } from 'generated/CoreApi_v1';
import { Formaters } from 'lib/Formaters';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    badgeId: string;
    userId?: string;
    onClose: () => void;
}

////////////////////////////////////////////////////////////////////////////

export const BadgeInfoDialog: React.FC<IProps> = ({ badgeId, userId, onClose }) => {

    const api = useCoreApi();
    const { t } = useTranslation("award");

    const [loading, setLoading] = useState<boolean>(true);
    const [viewData, setViewData] = useState<BadgeInfoResponse>();
    const [error, setError] = useState<any>();

    useEffect(() => {
        api.v1.badge.getBadgeInfo({ badgeId, userId: userId ?? null })
            .then(response => setViewData(response.data))
            .catch(e => setError(e))
            .finally(() => setLoading(false));
    }, []);

    return (
        <MprcSimpleDialog
            width="sm"
            title={t("BadgeInfoDialog.Title")}
            message={
                <>
                    {error
                        ? <MprcRequestErrorReport error={error} />
                        : loading
                            ? <MprcSpinnerIndicator />
                            : viewData && (
                                <>
                                    <Stack direction="row" spacing={4}>
                                        <Avatar
                                            variant="square"
                                            src={viewData.thumbnailUrl}
                                            sx={{
                                                width: 147,
                                                height: 196
                                            }}
                                        />
                                        <Box>
                                            <Typography variant="h2" color="muted.dark">{viewData.name}</Typography>
                                            <Typography variant="caption">{viewData.lastGrantedOn ? viewData.descriptionAfterWin : viewData.descriptionBeforeWin}</Typography>
                                        </Box>
                                    </Stack>
                                    <Stack alignItems="center" spacing={1} mt={2}>
                                        {viewData?.grantPoints &&
                                            <Stack direction="row" alignItems="flex-start" spacing={1}>
                                                <FontAwesomeIcon icon={faStars} size="lg" />
                                                <Typography variant="body1" color="muted">
                                                    <Trans
                                                        t={t}
                                                        i18nKey={"BadgeInfoDialog.GrantPointsText"}
                                                        values={{ count: viewData.grantPoints }}
                                                    />
                                                </Typography>
                                            </Stack>
                                        }
                                        {viewData.lastGrantedOn &&
                                            <Typography variant="body1" color="success">
                                                <Trans
                                                    t={t}
                                                    i18nKey={"BadgeInfoDialog.GrantedCountText"}
                                                    values={{ count: viewData.grantedCount, date: Formaters.dayMonth(viewData.lastGrantedOn) }}
                                                />
                                            </Typography>
                                        }
                                    </Stack>
                                </>
                            )
                    }
                </>
            }
            onClose={onClose}
        />
    );
};
